import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type ButtonAlertsPendingSyncContextValue = {
  /** Se incrementa tras gestionar una alarma desde cualquier punto de la app; los paneles deben volver a cargar `/button-alerts/pending`. */
  pendingListGeneration: number;
  notifyPendingButtonAlertsChanged: () => void;
};

const ButtonAlertsPendingSyncContext = createContext<ButtonAlertsPendingSyncContextValue | null>(null);

export function ButtonAlertsPendingSyncProvider({ children }: { children: React.ReactNode }) {
  const [pendingListGeneration, setPendingListGeneration] = useState(0);
  const notifyPendingButtonAlertsChanged = useCallback(() => {
    setPendingListGeneration((g) => g + 1);
  }, []);

  const value = useMemo(
    () => ({ pendingListGeneration, notifyPendingButtonAlertsChanged }),
    [pendingListGeneration, notifyPendingButtonAlertsChanged]
  );

  return (
    <ButtonAlertsPendingSyncContext.Provider value={value}>{children}</ButtonAlertsPendingSyncContext.Provider>
  );
}

export function useButtonAlertsPendingSync(): ButtonAlertsPendingSyncContextValue {
  const ctx = useContext(ButtonAlertsPendingSyncContext);
  if (!ctx) {
    throw new Error('useButtonAlertsPendingSync debe usarse dentro de ButtonAlertsPendingSyncProvider');
  }
  return ctx;
}
